import React, {useContext, useState} from 'react';
import {ExchangeRateExample} from "../types";
import LocResourcesContext from "../../../common/src/contexts/LocResourcesContext";
import howToOne from "../assets/img/how-to--01.png"
import howToOneBigger from "../assets/img/how-to--01@2x.png"
import howToTwo from "../assets/img/how-to--02.png"
import howToTwoBigger from "../assets/img/how-to--02@2x.png"
import howToThree from "../assets/img/how-to--03.png"
import howToThreeBigger from "../assets/img/how-to--03@2x.png"
import sanitizeHtml from "sanitize-html-react";

type ExchangeRateExampleComponentProps = {
    exchangeRateExample: ExchangeRateExample;
}

const ExchangeRateExampleComponent: React.FC<ExchangeRateExampleComponentProps> = ({exchangeRateExample}) => {
    const GLOBAL_PREFIX: string = "loy-bppo-benefitsContainer";
    const { onFormatLocale, onFormatPrice } = useContext(LocResourcesContext);

    const renderBenefitsContainer = () => {
        return <div className={`${GLOBAL_PREFIX}`}>
            <div data-utils-v3="text-left" id="loy-bppo-what-are-zoopoints" className="v3-h3">
                {onFormatLocale("loy.points.howtobenefit")}
            </div>
            <div data-grid-v3="grid" className={`${GLOBAL_PREFIX}__columns`}>
                <div data-grid-v3="col-start-1 col-12 col-start-1@md col-4@md"
                     data-utils-v3="margin-bottom--md margin-bottom--none@md">
                    <div data-grid-v3="grid gap-none grid-rows-2 grid-rows-3@md">
                <span data-grid-v3="row-start-1@md row-1@md col-start-1 col-2 row-start-1 row-2 col-start-1@md col-12@md">
                    <img className={`${GLOBAL_PREFIX}__diagramImg`} src={howToOne}
                         srcSet={howToOne + " 1x, " + howToOneBigger + " 2x"}/>
                </span>
                        <div data-utils-v3="text-left" className="v3-p1--bold"
                             data-grid-v3="row-start-2@md row-1@md row-start-1 row-1 col-start-4 col-10 col-start-1@md col-12@md">
                            {onFormatLocale("loy.points.collect")}</div>
                        <div className={`${GLOBAL_PREFIX}__columns--descriptions`}
                             data-grid-v3="row-start-3@md row-1@md row-start-2 row-3 col-start-4 col-10 col-start-1@md col-12@md"
                             data-utils-v3="text-left margin-top--sm@md margin-top--xs"
                             dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.collect2"))}}>
                        </div>
                    </div>
                </div>

                <div data-grid-v3="col-start-1 col-12 col-start-5@md col-4@md"
                     data-utils-v3="margin-bottom--md margin-bottom--none@md">
                    <div data-grid-v3="grid gap-none grid-rows-2 grid-rows-3@md">
                <span data-grid-v3="row-start-1@md row-1@md col-start-1 col-2 row-start-1 row-2 col-start-1@md col-12@md">
                    <img className={`${GLOBAL_PREFIX}__diagramImg`} src={howToTwo}
                         srcSet={howToTwo + " 1x, " + howToTwoBigger + " 2x"}/>
                </span>
                        <div data-utils-v3="text-left" className="v3-p1--bold"
                             data-grid-v3="row-start-2@md row-1@md row-start-1 row-1 col-start-4 col-10 col-start-1@md col-12@md">
                            {onFormatLocale("loy.points.earn")}</div>
                        <div className={`${GLOBAL_PREFIX}__columns--descriptions`}
                             data-grid-v3="row-start-3@md row-1@md row-start-2 row-3 col-start-4 col-10 col-start-1@md col-12@md"
                             data-utils-v3="text-left margin-top--sm@md margin-top--xs"
                             dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.earn2",
                                     onFormatPrice(exchangeRateExample.rate.amount, exchangeRateExample.rate.currency)))}}>
                        </div>
                    </div>
                </div>

                <div data-grid-v3="col-start-1 col-12 col-start-9@md col-4@md">
                    <div data-grid-v3="grid gap-none grid-rows-2 grid-rows-3@md">
                <span data-grid-v3="row-start-1@md row-1@md col-start-1 col-2 row-start-1 row-2 col-start-1@md col-12@md">
                    <img className={`${GLOBAL_PREFIX}__diagramImg`} src={howToThree}
                         srcSet={howToThree + " 1x, " + howToThreeBigger + " 2x"}/>
                </span>
                        <div data-utils-v3="text-left" className="v3-p1--bold"
                             data-grid-v3="row-start-2@md row-1@md row-start-1 row-1 col-start-4 col-10 col-start-1@md col-12@md">
                            {onFormatLocale("loy.points.redeem")}</div>
                        <div className={`${GLOBAL_PREFIX}__columns--descriptions`} data-utils-v3="text-left margin-top--sm@md margin-top--xs"
                             data-grid-v3="row-start-3@md row-1@md row-start-2 row-3 col-start-4 col-10 col-start-1@md col-12@md"
                             dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.redeem2"))}}>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    const renderRules = () => {
        return <div>
            <div data-utils-v3="margin-top--lg@md margin-top--md" className="v3-p1--bold">
                {onFormatLocale("loy.points.rules.title")}
            </div>
            <div>
                <div data-utils-v3="margin-top--sm@md margin-top--xs"
                     dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.rules.1", {
                         0: onFormatPrice(exchangeRateExample.rate.amount, exchangeRateExample.rate.currency),
                         1: onFormatPrice(exchangeRateExample.thresholdAmount.amount, exchangeRateExample.thresholdAmount.currency),
                         2: onFormatPrice(exchangeRateExample.exampleOrderPrice1.amount, exchangeRateExample.exampleOrderPrice1.currency),
                         3: exchangeRateExample.exampleOrderPoints1,
                         4: onFormatPrice(exchangeRateExample.exampleOrderPrice2.amount, exchangeRateExample.exampleOrderPrice2.currency),
                         5: exchangeRateExample.exampleOrderPoints2}))}}>
                </div>
                <p dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.rules.2"))}}/>
                <p dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.rules.3"))}}/>
                <p dangerouslySetInnerHTML={{__html: sanitizeHtml(onFormatLocale("loy.points.rules.4"))}}/>
            </div>
        </div>
    }

    return (
        <>
            {renderBenefitsContainer()}
            {renderRules()}
        </>)
}

export default ExchangeRateExampleComponent;
